import { useLocation, useParams } from 'react-router-dom';

import PageViewedTrackerSync from './PageViewedTrackerSync';
/**
 * This component ensures that clickstream fires a Page Viewed on path change
 *
 * @component
 * @returns {Element}
 */
export default function TrackPageView() {
  const { pathname } = useLocation();

  const { flowPage } = useParams();

  if (!pathname) {
    return null;
  }

  // convert the flowPage to Title Case from kebab-case
  const pageName = flowPage
    ?.split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return (
    <PageViewedTrackerSync
      // !Note: Do not remove the "key" prop. The key prop is used to force the component to re-render when the pathname changes allowing the track event to be fire on each page load.
      key={pathname}
      customDestinationPageName_={pageName}
    />
  );
}
